<br>
<div class="col-lg-12">
  <h4 style="text-align: center;">REPORTE DE BENEFICIARIOS</h4>
  <br>

  <!-- FILTROS -->
  <div class="row">
    <div class="col-md-12">
      <label>PERI DESDE:</label>&nbsp;
      <input maxlength="5" style="width: 60px;" type="text" [(ngModel)]="filtroPeriodoDesde" placeholder="YY/MM">
      &nbsp;
      <label>PERI HASTA:</label>&nbsp;
      <input maxlength="5" style="width: 60px;" type="text" [(ngModel)]="filtroPeriodoHasta" placeholder="YY/MM">
      &nbsp;
      <label>CUIL:</label>&nbsp;
      <app-cuit-input [(ngModel)]="filtroCuil" inputStyle="width: 130px;"></app-cuit-input>
      &nbsp;
      <label>CUIT EMPRESA:</label>&nbsp;
      <app-cuit-input [(ngModel)]="filtroCuit" inputStyle="width: 130px;"></app-cuit-input>
      &nbsp;
      <label>NOMBRE:</label>&nbsp;
      <input maxlength="60" style="width: 150px;" type="text" [(ngModel)]="filtroNombre" placeholder="Buscar...">
      &nbsp;
      <label>MIN. BENEF:</label>&nbsp;
      <select [(ngModel)]="filtroMinBeneficiarios" style="padding: 5px; border: 1px solid #ccc; border-radius: 3px;">
        <option [value]="0">Todos</option>
        <option [value]="-1">Excluir sin benef.</option>
        <option [value]="-2">Solo sin benef.</option>
        <option [value]="1">1+</option>
        <option [value]="2">2+</option>
        <option [value]="3">3+</option>
        <option [value]="4">4+</option>
        <option [value]="5">5+</option>
      </select>
      &nbsp;
      <button [disabled]="filtroPeriodoDesde.length < 5 || filtroPeriodoHasta.length < 5"
              type="button" class="btn btn-primary"
              (click)="buscarTitulares()">
        <span *ngIf="!loading">CONSULTAR</span>
        <span *ngIf="loading">PROCESANDO...</span>
        <i *ngIf="loading" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
      </button>
      &nbsp;
      <button [disabled]="dataSource.length === 0"
              type="button" class="btn btn-success"
              data-toggle="modal" data-target="#modalExportar"
              (click)="abrirModalExportar()">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>&nbsp;EXPORTAR
      </button>
      &nbsp;
      <button type="button" class="btn btn-secondary" (click)="limpiarFiltros()">
        <i class="fa fa-eraser" aria-hidden="true"></i>&nbsp;LIMPIAR
      </button>
    </div>
  </div>

  <hr>

  <!-- TABLA PRINCIPAL -->
  <div *ngIf="dataSource.length > 0" class="animated fadeIn">
    <h5>
      Resultados: <span class="badge badge-primary">{{totalRecords}} titulares</span>
      (pagina {{pageIndex + 1}} de {{getTotalPages()}})
    </h5>

    <!-- PAGINADOR SUPERIOR -->
    <div class="custom-paginator">
      <div class="paginator-total">
        <span class="badge badge-primary">Total: {{totalRecords}} registros</span>
      </div>
      <div class="paginator-page-size">
        <label>Registros por pagina:&nbsp;</label>
        <select [(ngModel)]="pageSize" (change)="changePageSize(pageSize)" class="form-control form-control-sm" style="width: auto; display: inline-block;">
          <option [value]="100">100</option>
          <option [value]="500">500</option>
          <option [value]="1000">1000</option>
          <option [value]="2000">2000</option>
        </select>
      </div>
      <div class="paginator-navigation">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(0)">
          <i class="fa fa-angle-double-left"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
          <i class="fa fa-angle-left"></i>
        </button>
        <span *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'" class="btn btn-sm"
                  [class.btn-primary]="page === pageIndex"
                  [class.btn-outline-secondary]="page !== pageIndex"
                  (click)="goToPage(page)">
            {{page + 1}}
          </button>
          <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
        </span>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(pageIndex + 1)">
          <i class="fa fa-angle-right"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(getTotalPages() - 1)">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </div>

    <!-- TABLA DE TITULARES -->
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows>

      <!-- CUIL Titular -->
      <ng-container matColumnDef="cuil_titular">
        <th mat-header-cell *matHeaderCellDef>CUIL TITULAR</th>
        <td mat-cell *matCellDef="let element">{{element.cuil_titular}}</td>
      </ng-container>

      <!-- Nombre -->
      <ng-container matColumnDef="nombre_titular">
        <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
        <td mat-cell *matCellDef="let element">{{element.nombre_titular}}</td>
      </ng-container>

      <!-- CUIT Empleador -->
      <ng-container matColumnDef="Cuit_Empleador">
        <th mat-header-cell *matHeaderCellDef>CUIT EMPLEADOR</th>
        <td mat-cell *matCellDef="let element">{{element.Cuit_Empleador}}</td>
      </ng-container>

      <!-- Empresa -->
      <ng-container matColumnDef="Razon_Social">
        <th mat-header-cell *matHeaderCellDef>EMPRESA</th>
        <td mat-cell *matCellDef="let element">{{element.Razon_Social}}</td>
      </ng-container>

      <!-- Periodo -->
      <ng-container matColumnDef="Periodo">
        <th mat-header-cell *matHeaderCellDef>PERIODO</th>
        <td mat-cell *matCellDef="let element">{{element.Periodo}}</td>
      </ng-container>

      <!-- Remuneracion -->
      <ng-container matColumnDef="RemosImp">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;">REM. IMPONIBLE</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">{{element.RemosImp | currency:"$"}}</td>
      </ng-container>

      <!-- Total Beneficiarios -->
      <ng-container matColumnDef="total_beneficiarios">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">BENEFICIARIOS</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <span class="badge badge-info">{{element.total_beneficiarios}}</span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">VER</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <button mat-icon-button color="primary" (click)="toggleGrupoFamiliar(element)"
                  [title]="expandedElement === element ? 'Ocultar grupo familiar' : 'Ver grupo familiar'">
            <mat-icon>{{expandedElement === element ? 'expand_less' : 'expand_more'}}</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Fila expandida: Grupo Familiar -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div class="expanded-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <div *ngIf="element === expandedElement" class="grupo-familiar-container">
              <!-- Datos del Titular desde beneficiarios -->
              <div class="titular-detalle mb-3" *ngIf="element.ben_cuil">
                <h6><strong>Datos del Titular</strong></h6>
                <div class="row">
                  <div class="col-md-3"><strong>CUIL:</strong> {{element.ben_cuil}}</div>
                  <div class="col-md-3"><strong>Documento:</strong> {{element.ben_documento_tipo}} {{element.ben_documento_numero}}</div>
                  <div class="col-md-3"><strong>Sexo:</strong> {{element.ben_sexo}}</div>
                  <div class="col-md-3"><strong>Fecha Nac.:</strong> {{element.ben_fecha_nacimiento | date:'dd/MM/yyyy'}}</div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <strong>Direccion:</strong>
                    {{element.ben_calle}} {{element.ben_puerta}}
                    {{element.ben_piso ? 'Piso '+element.ben_piso : ''}}
                    {{element.ben_departamento ? 'Depto '+element.ben_departamento : ''}}
                    {{element.ben_codigo_postal ? '(CP '+element.ben_codigo_postal+')' : ''}}
                  </div>
                  <div class="col-md-3"><strong>Celular:</strong> {{element.ben_celular || '-'}}</div>
                  <div class="col-md-3"><strong>Seccional:</strong> {{element.ben_seccional}}</div>
                </div>
              </div>

              <div *ngIf="!element.ben_cuil" class="alert alert-warning">
                Este titular no tiene datos en la tabla de beneficiarios.
              </div>

              <hr>

              <h6><strong>Grupo Familiar de {{element.nombre_titular || element.cuil_titular}}</strong></h6>

              <div *ngIf="loadingGrupoFamiliar" class="text-center">
                <i class="fa fa-spinner fa-spin fa-2x"></i> Cargando...
              </div>

              <div *ngIf="!loadingGrupoFamiliar && grupoFamiliarData.length === 0" class="alert alert-warning">
                No se encontraron beneficiarios registrados para este titular.
              </div>

              <div *ngIf="!loadingGrupoFamiliar && grupoFamiliarData.length > 0" style="overflow-x: auto;">
                <table class="table table-sm table-striped grupo-familiar-table">
                  <thead>
                    <tr>
                      <th>CUIL</th>
                      <th>NOMBRE</th>
                      <th>PARENTESCO</th>
                      <th>DOCUMENTO</th>
                      <th>SEXO</th>
                      <th>FECHA NAC.</th>
                      <th style="text-align: center;">VER</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let beneficiario of grupoFamiliarData">
                      <tr [class.titular-row]="beneficiario.Parentesco === 0"
                          [class.beneficiario-expanded]="expandedBeneficiario === beneficiario">
                        <td>{{beneficiario.Cuil}}</td>
                        <td>{{beneficiario.ApellidoNombre}}</td>
                        <td>
                          <span [class.badge]="true"
                                [class.badge-primary]="beneficiario.Parentesco === 0"
                                [class.badge-secondary]="beneficiario.Parentesco !== 0">
                            {{beneficiario.Parentesco}} - {{beneficiario.parentesco_desc}}
                          </span>
                        </td>
                        <td>{{beneficiario.Documento_Tipo}} {{beneficiario.Documento_Numero}}</td>
                        <td>{{beneficiario.Sexo}}</td>
                        <td>{{beneficiario.Fecha_Nacimiento | date:'dd/MM/yyyy'}}</td>
                        <td style="text-align: center;">
                          <button mat-icon-button color="accent" (click)="toggleBeneficiario(beneficiario)"
                                  [title]="expandedBeneficiario === beneficiario ? 'Ocultar detalle' : 'Ver detalle'">
                            <mat-icon>{{expandedBeneficiario === beneficiario ? 'expand_less' : 'expand_more'}}</mat-icon>
                          </button>
                        </td>
                      </tr>
                      <!-- Fila de detalle expandida -->
                      <tr *ngIf="expandedBeneficiario === beneficiario" class="beneficiario-detalle-row">
                        <td colspan="7">
                          <div class="beneficiario-detalle">
                            <div class="row">
                              <div class="col-md-3">
                                <strong>Discapacitado:</strong>
                                <span [class.badge]="true"
                                      [class.badge-warning]="beneficiario.Discapacitado === 'SI'"
                                      [class.badge-light]="beneficiario.Discapacitado !== 'SI'">
                                  {{beneficiario.Discapacitado}}
                                </span>
                              </div>
                              <div class="col-md-3"><strong>Estado Civil:</strong> {{beneficiario.EstadoCivil || '-'}}</div>
                              <div class="col-md-3"><strong>Nacionalidad:</strong> {{beneficiario.Nacionalidad || '-'}}</div>
                              <div class="col-md-3">
                                <strong>Alta:</strong> {{beneficiario.Fecha_Alta | date:'dd/MM/yyyy'}}
                                &nbsp;|&nbsp;
                                <strong>Baja:</strong> {{beneficiario.Fecha_Baja && beneficiario.Fecha_Baja !== '0000-00-00' ? (beneficiario.Fecha_Baja | date:'dd/MM/yyyy') : '-'}}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <strong>Dirección:</strong>
                                {{beneficiario.Calle}} {{beneficiario.Puerta}}
                                {{beneficiario.Piso ? 'Piso '+beneficiario.Piso : ''}}
                                {{beneficiario.Departamento ? 'Depto '+beneficiario.Departamento : ''}}
                                {{beneficiario.Codigo_Postal ? '(CP '+beneficiario.Codigo_Postal+')' : ''}}
                              </div>
                              <div class="col-md-3"><strong>Localidad:</strong> {{beneficiario.Localidad || '-'}}</div>
                              <div class="col-md-3"><strong>Provincia:</strong> {{beneficiario.Provincia || '-'}}</div>
                            </div>
                            <div class="row">
                              <div class="col-md-3"><strong>Celular:</strong> {{beneficiario.Celular || '-'}}</div>
                              <div class="col-md-3"><strong>Teléfono:</strong> {{beneficiario.Telefono || '-'}}</div>
                              <div class="col-md-6"><strong>Mail:</strong> {{beneficiario.Mail || '-'}}</div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"
          class="element-row"
          [class.expanded-row]="expandedElement === element">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>

    <!-- PAGINADOR INFERIOR -->
    <div class="custom-paginator">
      <div class="paginator-total">
        <span class="badge badge-primary">Total: {{totalRecords}} registros</span>
      </div>
      <div class="paginator-page-size">
        <label>Registros por pagina:&nbsp;</label>
        <select [(ngModel)]="pageSize" (change)="changePageSize(pageSize)" class="form-control form-control-sm" style="width: auto; display: inline-block;">
          <option [value]="100">100</option>
          <option [value]="500">500</option>
          <option [value]="1000">1000</option>
          <option [value]="2000">2000</option>
        </select>
      </div>
      <div class="paginator-navigation">
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(0)">
          <i class="fa fa-angle-double-left"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
          <i class="fa fa-angle-left"></i>
        </button>
        <span *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'" class="btn btn-sm"
                  [class.btn-primary]="page === pageIndex"
                  [class.btn-outline-secondary]="page !== pageIndex"
                  (click)="goToPage(page)">
            {{page + 1}}
          </button>
          <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
        </span>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(pageIndex + 1)">
          <i class="fa fa-angle-right"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" [disabled]="pageIndex >= getTotalPages() - 1" (click)="goToPage(getTotalPages() - 1)">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mensaje sin resultados -->
  <div *ngIf="dataSource.length === 0 && !loading" class="alert alert-info mt-3">
    <i class="fa fa-info-circle"></i> Utilice los filtros para buscar titulares y sus beneficiarios.
  </div>

</div>

<!-- MODAL DE EXPORTACION -->
<div class="modal fade" id="modalExportar" tabindex="-1" role="dialog" aria-labelledby="modalExportarLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalExportarLabel">
          <i class="fa fa-file-excel-o"></i> Exportar a Excel
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Selector de columnas -->
        <div class="row mb-3">
          <div class="col-12">
            <h6>Seleccione las columnas a exportar:</h6>
            <button type="button" class="btn btn-sm btn-outline-primary mr-2" (click)="seleccionarTodas()">
              Seleccionar todas
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="deseleccionarTodas()">
              Deseleccionar todas
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4" *ngFor="let col of columnasExportables">
            <div class="form-check">
              <input class="form-check-input" type="checkbox"
                     [(ngModel)]="col.selected" [id]="'col_' + col.key">
              <label class="form-check-label" [for]="'col_' + col.key">
                {{col.label}}
              </label>
            </div>
          </div>
        </div>

        <hr>

        <!-- Preview -->
        <h6>Preview (primeros 5 registros):</h6>
        <div class="table-responsive preview-container" *ngIf="getColumnasSeleccionadas().length > 0">
          <table class="table table-sm table-bordered preview-table">
            <thead>
              <tr>
                <th *ngFor="let col of getColumnasSeleccionadas()">{{col.label}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of previewData">
                <td *ngFor="let col of getColumnasSeleccionadas()">
                  <span *ngIf="col.key === 'RemosImp'">{{row[col.key] | currency:'$'}}</span>
                  <span *ngIf="col.key !== 'RemosImp'">{{row[col.key]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="getColumnasSeleccionadas().length === 0" class="alert alert-warning">
          <i class="fa fa-exclamation-triangle"></i> Seleccione al menos una columna para ver el preview.
        </div>

        <div class="alert alert-info mt-2" *ngIf="getColumnasSeleccionadas().length > 0">
          <i class="fa fa-info-circle"></i>
          Se exportaran <strong>{{dataSource.length}}</strong> registros con
          <strong>{{getColumnasSeleccionadas().length}}</strong> columnas.
        </div>
      </div>
      <div class="modal-footer">
        <button id="cerrarModalExportar" type="button" class="btn btn-secondary" data-dismiss="modal">
          Cancelar
        </button>
        <button type="button" class="btn btn-danger"
                [disabled]="getColumnasSeleccionadas().length === 0"
                (click)="exportarPdfConColumnas()">
          <i class="fa fa-file-pdf-o"></i> Exportar PDF
        </button>
        <button type="button" class="btn btn-success"
                [disabled]="getColumnasSeleccionadas().length === 0"
                (click)="exportarExcelConColumnas()">
          <i class="fa fa-file-excel-o"></i> Exportar Excel
        </button>
      </div>
    </div>
  </div>
</div>

<br><br>
